<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 25">
    <title v-if="title">{{ title }}</title>
    <path
      d="m17.88 0-.96.961 3.48 3.482H2.405c-.775 0-1.403.627-1.405 1.402V12h1.358V5.845c0-.024.02-.044.044-.044h17.994l-3.477 3.482.961.961L23 5.122 17.88 0zM23 12h-1.358v6.842c0 .025-.02.046-.044.046H3.604l3.477-3.668-.961-1.012L1 19.604 6.12 25l.96-1.013L3.6 20.32h17.994c.775 0 1.404-.662 1.406-1.478V12z"
      fill="#93AB39"
      fill-rule="nonzero"
      stroke="#93AB39"
      stroke-width=".3"
    />
  </svg>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: undefined,
  },
});
</script>
